import React from "react";
import SvgIcon from "@mui/material/SvgIcon";
import { useTheme } from "@mui/material/styles";
const LinkedInIcon = (props: { [x: string]: any }): JSX.Element => {
  const theme = useTheme() as any;

  return (
    <SvgIcon {...props}>
      <g
        id="LinkedInIcon"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <path
          d="M3,18.7805452 L3,3.36698621 C3,2.65516956 3.5936973,2.07821584 4.3260945,2.07821584 L19.618795,2.07821584 C20.3511681,2.07821584 20.9448895,2.65516956 20.9448895,3.36698621 L20.9448895,18.7805452 C20.9448895,19.4921214 20.3511681,20.0693155 19.618795,20.0693155 L4.3260945,20.0693155 C3.5936973,20.0693155 3,19.4921214 3,18.7805452 Z M9.93941033,5.14753136 C9.93941033,5.14753136 9.97505051,12.5092204 9.93948272,13.2715205 L12.6498736,13.2715205 L12.6498736,12.0933329 L12.631776,12.0933329 C12.988419,12.6479297 13.6303283,13.4621556 15.0925166,13.4621556 C16.8757561,13.4621556 18.2129264,12.3010363 18.2129264,9.80571143 L18.2129264,5.14753136 L15.5027527,5.14753136 L15.5027527,9.49367563 C15.5027527,10.5858009 15.1104212,11.3307924 14.1296527,11.3307924 C13.3808953,11.3307924 12.9349226,10.8283619 12.7389861,10.34324 C12.6674161,10.1696731 12.6498012,9.92711211 12.6498012,9.68431075 L12.6498012,5.14753136 L9.93941033,5.14753136 Z M8.43965141,5.14753136 L5.72923645,5.14753136 L5.72923645,13.2715205 L8.43965141,13.2715205 L8.43965141,5.14753136 Z M7.08443186,14.380714 L7.0843836,14.380714 L7.06676862,14.380714 C6.15718401,14.380714 5.5690125,15.0045452 5.5690125,15.7841539 C5.5690125,16.5813116 6.1752092,17.1878342 7.10236054,17.1878342 C8.0296084,17.1878342 8.60028557,16.5813116 8.61790056,15.7841539 C8.61790056,15.0045452 8.0296084,14.380714 7.08443186,14.380714 Z"
          id="path14-2"
          fill={theme.palette.iconColor}
          transform="translate(11.972445, 11.073766) scale(1, -1) translate(-11.972445, -11.073766) "
        />
      </g>
    </SvgIcon>
  );
};

export default LinkedInIcon;
